import type { CmsContentBlock, CmsPartialBlock } from '#src/interfaces/CmsConfig'

const isCmsPartialBlock = (contentBlock: CmsContentBlock): contentBlock is CmsPartialBlock =>
  !!(contentBlock as CmsPartialBlock).partial

const getCmsContentBlockHtml = (contentBlock: CmsContentBlock) =>
  (isCmsPartialBlock(contentBlock) ? contentBlock.partial.code : contentBlock.code).replace(
    /\n/g,
    ''
  )

export { getCmsContentBlockHtml }
